import { CalendarType } from '@/hooks/useGoogleCalendar';
import dayjs from 'dayjs';
import { useQuery } from '@tanstack/react-query';

const API_BASE_URL = process.env.REACT_APP_API_URL;

const requestCalendar = async (type, query, date) => {
  const timeMin = dayjs(date).startOf('month').toISOString();
  const timeMax = dayjs(date).endOf('month').toISOString();

  try {
    const params = new URLSearchParams({
      type,
      timeMin,
      timeMax,
      ...(query && { query }),
    });

    const response = await fetch(
      `${API_BASE_URL}/google-calendar/events?${params.toString()}`
    );

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    // 백엔드 응답 구조에 맞게 수정
    if (data.statusCode === 200 && data.data) {
      return data.data;
    }
    return [];
  } catch (err) {
    console.error('useQueryCalendar - API Error:', err);
    return [];
  }
};

const requestYearlyCalendar = async (type, query = '') => {
  const timeMin = dayjs().startOf('day').toISOString();
  const timeMax = dayjs().add(1, 'year').endOf('day').toISOString();

  try {
    const params = new URLSearchParams({
      type,
      timeMin,
      timeMax,
      ...(query && { query }),
    });

    const response = await fetch(
      `${API_BASE_URL}/google-calendar/events?${params.toString()}`
    );

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    // 백엔드 응답 구조에 맞게 수정
    if (data.statusCode === 200 && data.data) {
      return data.data;
    }
    return [];
  } catch (err) {
    console.error('useQueryYearlyCalendar - API Error:', err);
    return [];
  }
};

const useQueryCalendar = (
  type,
  query = '',
  date = new Date(),
  enabled = true
) => {
  const apiMethod = requestCalendar;

  return useQuery({
    queryKey: ['calendar', type, query, dayjs(date).format('YYYY-MM')],
    queryFn: () => apiMethod(type, query, date),
    staleTime: 1000 * 60 * 60 * 1,
    enabled: enabled,
  });
};

const useQueryYearlyCalendar = (type, query = '', enabled = true) => {
  const apiMethod = requestYearlyCalendar;

  return useQuery({
    queryKey: ['yearlyCalendar', type, query],
    queryFn: () => apiMethod(type, query),
    staleTime: 1000 * 60 * 60 * 1,
    enabled: enabled,
  });
};

export {
  requestCalendar,
  requestYearlyCalendar,
  useQueryCalendar,
  useQueryYearlyCalendar,
};
